<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="ve_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ve_name || "供应商名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ve_name"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ve_address">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_address || "公司地址"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.ve_address" placeholder="请填写" />
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells_hd">交易信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <currency-field slot="ve_currency" :label="customLabel.ve_currency || '默认币种'"  v-model="form.main.ve_currency" :use-default="true" />
        <div class="weui-cell" slot="ve_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_taxrate || "税率(%)"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.ve_taxrate"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ve_bankcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_bankcode || "开户银行"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.ve_bankcode" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell" slot="ve_bankaccount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_bankaccount || "银行账号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ve_bankaccount"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field slot="ve_payments" :label="customLabel.ve_payments || '付款方式 '" :is-rec="false" v-model="form.main.ve_payments" @select="onSelectPayment" />
        <employee-field slot="ve_buyername" :label="customLabel.ve_buyername || '采购员 '" v-model="form.main.ve_buyername" @select="onSelectEmployee" />
        <div class="weui-cell" slot="ve_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ve_remark || "变更原因"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ve_remark"
              placeholder="请填写"
            />
          </div>
        </div>
        <custom-field 
          :label="customLabel.ve_text1 || '自定义字段1'"
          v-model="form.main.ve_text1" :caller="caller" fieldName="ve_text1"
          slot="ve_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.ve_text2 || '自定义字段2'"
          v-model="form.main.ve_text2" :caller="caller" fieldName="ve_text2"
          slot="ve_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.ve_text3 || '自定义字段3'"
          v-model="form.main.ve_text3" :caller="caller" fieldName="ve_text3"
          slot="ve_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.ve_text4 || '自定义字段4'"
          v-model="form.main.ve_text4" :caller="caller" fieldName="ve_text4"
          slot="ve_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.ve_text5 || '自定义字段5'"
          v-model="form.main.ve_text5" :caller="caller" fieldName="ve_text5"
          slot="ve_text5" hidden="true"
        />
       
      </custom-layout>
      <div class="weui-cells">
        <file-field v-model="form.main.ve_attach" ref="ve_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import FileField from "@/components/field/FileField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CurrencyField,
    FileField,
    PaymentField,
    EmployeeField,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/vendor",
      codeField: "ve_code",
      statusField: "ve_audit_status_code",
      caller: "VendorChange",
      xtype: "vendor-change-formpanel",
      form: {
        main: {
          ve_taxrate: 0
        }
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main
      if (!main.ve_name) {
        me.$weui.topTips("请填写供应商名称", 2000);
      } else if (!main.ve_address) {
        me.$weui.topTips("请填写公司地址", 2000);
      } else if (!main.ve_taxrate) {
        me.$weui.topTips("请填写税率", 2000);
      } else if (!main.ve_bankcode) {
        me.$weui.topTips("请填写开户银行", 2000);
      } else if (!main.ve_bankaccount) {
        me.$weui.topTips("请填写银行账号", 2000);
      } else if (!main.ve_currency) {
        me.$weui.topTips("请选择默认币种", 2000);
      } else if (!main.ve_payments) {
        me.$weui.topTips("请选择付款方式", 2000);
      } else if (!main.ve_buyername) {
        me.$weui.topTips("请选择采购员", 2000);
      } else if (!main.ve_remark) {
        me.$weui.topTips("请填写变更原因", 2000);
      } else {
        me.p_save();
      }
    },
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.ve_paymentsid = selection.id;
      main.ve_paymentscode = selection.pa_code;
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.ve_buyerid = selection.id;
      main.ve_buyercode = selection.em_code;
    },
    p_save() {
      var me = this, jsonData = me.form.main, caller = me.caller, xtype = me.xtype
      me.$loading({
        method: "post",
        url: "/api/document/vendor/modifyDetail",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.preLaunchProcess(caller, res.data.change, xtype,
          function () {
            me.p_router_to_read(res.data.id);
          });
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    }
  }
};
</script>